import { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../context/context'
import { baseUrl } from '../../config/delcare'
import UiButton1 from '../../components/ui_button1';
import UiInput1 from '../../components/ui_input1';
import UiSpinner from '../../components/ui_spinner';

const Account = () => {

    const {
        neonUser, token,
        countries, getAllCountries,
        ww,
        offCanvas,
        setSideBarTitle,
        setPopupSidebarType,
        fetchDataV2,
    } = useContext(AppContext)

    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const [generalMessage, setGeneralMessage] = useState("")
    const [userLocal, setUserLocal] = useState({})

    const userChangeHandler = (value, field) => {
        setUserLocal({
            ...userLocal,
            [field]: value
        })
    }

    const submitHandler = async () => {
		// console.log("USER LOCAL INFO", userLocal)
        setLoading(true)
        setGeneralMessage("")
        setError(null)
	

        if (!userLocal.first_name || !userLocal.agency_name) {
            setGeneralMessage("First name and company name must not be empty")
            setError(true)
            setLoading(false)
            return
        }

        let query1 = "ACCOUNT_SUBMIT_1", params1 = [userLocal.first_name, userLocal.last_name, userLocal.user_id]
        // let query2 = "ACCOUNT_SUBMIT_2", params2 = [userLocal.agency_name, userLocal.country, userLocal.user_id]
		let query2 = "ACCOUNT_SUBMIT_2", params2 = [userLocal.agency_name, userLocal.country, userLocal.agency_id]

        try {
            await Promise.all([
                fetchDataV2(query1, params1, "/neon-query-v2"),
                fetchDataV2(query2, params2, "/neon-query-v2"),
            ])
        } catch (err) {
            setGeneralMessage("Something went wrong, Please try again.")
            setError(true)
            setLoading(false)
            return
        }

        document.querySelector('#viewEl').scrollTo({ top: 0, behavior: 'smooth' })
        setGeneralMessage("Profile info updated.")
        setError(false)
        setLoading(false)
        return
    }

    const promptChangeEmail = async () => {
        setSideBarTitle("Change Email Address")
        setPopupSidebarType("change_email")
        offCanvas.show()
        return
    }

    useEffect(() => {
        if (countries.length == 0) getAllCountries()
    }, [])

    useEffect(() => {
        if (neonUser.user_id && !userLocal.user_id) setUserLocal({ ...neonUser })
    }, [neonUser])

    return (
        <div className={"gap-3 d-flex flex-column " + (ww < 400 ? "px-1 pt-4 " : "p-4")}>
            <div className="d-flex gap-2">
                <p className="align-self-center mb-1 fs-4">Update Profile</p>
            </div>
            <div style={{ maxWidth: 1600 }}>
                <div className="container1">
                    <div className="flex-column d-flex gap-4" style={{ maxWidth: 900 }}>
                        {generalMessage ? <p className={"poppins " + (error ? 'text-danger' : error == false ? 'text-success' : '')}>{generalMessage}</p> : null}
                        <div className="container">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <p className="poppins mb-1 fw-bold">EMAIL ADDRESS</p>
                                    <UiInput1 field="email" value={userLocal.email || ''} userChangeHandler={userChangeHandler} readOnly={true} />
                                </div>
                                <div className="col-md-6 d-flex flex-column justify-content-end pt-3">
                                    <div style={{ maxWidth: 250 }}>
                                        <UiButton1 text="Change Email" submit={promptChangeEmail} />
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <p className="poppins mb-1 fw-bold">FIRST NAME</p>
                                    <UiInput1 field="first_name" value={userLocal.first_name || ''} userChangeHandler={userChangeHandler} />
                                </div>
                                <div className="col-md-6">
                                    <p className="poppins mb-1 fw-bold">LAST NAME</p>
                                    <UiInput1 field="last_name" value={userLocal.last_name || ''} userChangeHandler={userChangeHandler} />
                                </div>
                            </div>

                            {neonUser && ["owner"].includes(neonUser.role) &&
                                <>
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <p className="poppins mb-1 fw-bold">COMPANY</p>
                                            <UiInput1 field="agency_name" value={userLocal.agency_name || ''} userChangeHandler={userChangeHandler} />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <p className="poppins mb-1 fw-bold">COUNTRY</p>
                                            <UiInput1 field="country" countries={countries} value={userLocal.country} userChangeHandler={userChangeHandler} />
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                    <div style={{ maxWidth: 300 }} className='mt-4'>
                        {loading ?
                            <div className="d-flex justify-content-center">
                                <UiSpinner />
                            </div>
                            :
                            <UiButton1 text="Update Profile" submit={submitHandler} />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Account